import ActionTypes from '../constants/ActionTypes';
import { api } from '../api/index';

export const fetchLocation = id => {
  return async dispatch => {
    try {
      const { data: location } = await api.get(`location/${id}`);
      return dispatch({
        type: ActionTypes.FETCH_LOCATION_SUCCESS,
        payload: location
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_LOCATION_ERROR,
        payload: { id }
      });
    }
  };
};
